import { NgModule } from '@angular/core';
import { RevenueValuePipe } from './revenue-value.pipe';

@NgModule({
    declarations: [RevenueValuePipe],
    exports: [RevenueValuePipe],
})
export class RevenueValuePipeModule {}
